import { Stack, Text } from "@chakra-ui/react";

export const NotFoundScreen = () => {
  return (
    <Stack alignItems="center" justify="center" gap={4} minH="dvh">
      <Text
        textStyle="Heading/Large"
        fontWeight="bold"
        fontSize="58px"
        color="semantic.contents.tertiary"
        as="h2"
      >
        404
      </Text>
      <Text textStyle="Paragraph/Large" color="semantic.contents.tertiary">
        ページが見つかりませんでした。
      </Text>
    </Stack>
  );
};
